export const MODULE = 'HC';

export const GET_TRANSACTION = `${MODULE}/get_transaction`;
export const APPROVE_TRANSACTION = `${MODULE}/approve_transaction`;
export const REJECT_TRANSACTION = `${MODULE}/reject_transaction`;
export const UPDATE_TRANSACTION = `${MODULE}/update_transaction`;
export const SHOW_TRANSACTION = `${MODULE}/show_transaction`;
export const START_ASSESSMENT = `${MODULE}/start_assessment`;
export const GET_SETTINGS = `${MODULE}/get_settings`;
export const UPDATE_TEST_STATUS = `${MODULE}/update_health_status`;
export const TAG_AS_PRINTED = `${MODULE}/tag_as_printed`;
export const TAG_AS_RECIVED = `${MODULE}/tag_as_received`;
export const CHANGE_COLOR = `${MODULE}/change_color`;
export const EDIT_OHP = `${MODULE}/edit_ohp`;
export const GET_BUSINESS_ESTABLISMENT = `OHP/get_business_establishment`;
export const GET_BUSINESS_ESTABLISMENT_TWO = `${MODULE}/get_business_establishment_two`;
export const GET_INSTITUTION = `${MODULE}/get_institution`;
export const GET_WORK_DESCRIPTION = `${MODULE}/get_description`;
export const GET_CITIZENSHIP = `${MODULE}/get_citizenship`;
export const GET_APPOINTMENT_LOGS = `${MODULE}/get_logs`;
export const GET_APPOINTMENTS_LIST = 'APT/get_appointments_list';
export const SHOW_APPOINTMENTS = 'APT/show_appointments';
export const UPDATE_APPOINTMENT = `${MODULE}/update_appointment`;
export const OHP_CHECK = `${MODULE}/OHP_CHECK`;
export const INITIAL_APPROVE = `${MODULE}/initial_approve`;
export const INITIAL_REJECT = `${MODULE}/initial_reject`;

export const OCCUPATIONAL_PERMIT_URI =
  'api/v1/administrators/transaction_histories/occupational_permit/';
export const HEALTH_CERTIFICATE_URI =
  'api/v1/administrators/transaction_histories/health_certificate/';
export const ASSESS_RECEIPT = `${MODULE}/assess_receipt`;
export const VIEW_EOR =
  'api/v1/administrators/transaction_histories/health_certificate/';

export const DEPENDENCIES = {
  health_certificate_amount: {
    label: 'Health Certificate',
  },
  // occupational_permit_amount: {
  //   label: 'Occupational Permit',
  // },
  card_type: {
    label: 'CARD TYPE',
  },
  stool_amount: {
    label: 'Stool',
  },
  sputum_amount: {
    label: 'Sputum',
  },
  drug_test_amount: {
    label: 'Drug Test',
  },
  rpr_syphilis_amount: {
    label: 'RPR Syphilis',
  },
  gram_stain_amount: {
    label: 'Gram Stain',
  },
  xray_amount: {
    label: "X-Ray"
  }
};

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
  last_name: '',
  middle_name: '',
  first_name: '',
  extension_name: '',
  gender: '',
  mobile_number: '',
  telephone_number: '',
  birth_date: '',
  civil_status: '',
  highest_educational_attainment: '',
  institution_code: '',
  work_description_code: '',
  citizenship_code: '',
};

export const BUSINESS_FORM = {
  business_establishment_id: '',
  business_establishments: '',
  business_establishments_address: '',
  number_of_additional_copy: '',
};

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];

export const HIGHEST_EDUCATIONAL_ATTAINMENT = [
  {
    label: 'No Grade Completed',
    value: 'No Grade Completed',
  },
  {
    label: 'Preschool',
    value: 'Preschool',
  },
  {
    label: 'Elementary Undergraduate',
    value: 'Elementary Undergraduate',
  },
  {
    label: 'Elementary Graduate',
    value: 'Elementary Graduate',
  },
  {
    label: 'ALS Elementary',
    value: 'ALS Elementary',
  },
  {
    label: 'SPED Elementary',
    value: 'SPED Elementary',
  },
  {
    label: 'High School Undergraduate',
    value: 'High School Undergraduate',
  },
  {
    label: 'ALS Secondary',
    value: 'ALS Secondary',
  },
  {
    label: 'SPED Secondary',
    value: 'SPED Secondary',
  },
  {
    label: 'High School Graduate',
    value: 'High School Graduate',
  },
  {
    label: 'College Undergraduate',
    value: 'College Undergraduate',
  },
  {
    label: 'Post Secondary',
    value: 'Post Secondary',
  },
  {
    label: 'Post Secondary Graduate',
    value: 'Post Secondary Graduate',
  },
  {
    label: 'College Graduate',
    value: 'College Graduate',
  },
  {
    label: 'Post Baccalaureate',
    value: 'Post Baccalaureate',
  },
  {
    label: "Master's/PhD graduate",
    value: "Master's/PhD graduate",
  },
  {
    label: 'Not Reported',
    value: 'Not Reported',
  },
];

export const GENDER = [
  {
    label: 'MALE',
    value: 'MALE',
  },
  {
    label: 'FEMALE',
    value: 'FEMALE',
  },
];

export const CIVIL_STATUS = [
  {
    label: 'SINGLE',
    value: 'SINGLE',
  },
  {
    label: 'MARRIED',
    value: 'MARRIED',
  },
  {
    label: 'DIVORCED',
    value: 'DIVORCED',
  },
  {
    label: 'WIDOWED',
    value: 'WIDOWED',
  },
];

export const UPDATE_BUSINESS_EST = 'OHP/update_business_establishment';
export const REMOVE_BUSINESS_EST = 'OHP/remove_business_establishment';
export const CREATE_BUSINESS_EST = 'OHP/create_business_establishment';
